import React from 'react'
import { Link } from 'react-router-dom'
interface AvatarProps {
  name?: string
  action?: string
  href?: any
  image?: any
}

const Avatar = React.forwardRef<HTMLAnchorElement, AvatarProps>(
  ({ name, action, image, href, ...args }, ref) => {
    return (
      <Link
        className="inline-flex items-center justify-start space-x-5 w-80"
        ref={ref}
        to={href}
        {...args}
      >
        <div>
          <img
            className="flex-1 inline-block w-12 h-full rounded-full filter drop-shadow-3xl"
            src={image}
            alt={name}
          />
        </div>
        {name && (
          <div className="inline-flex flex-col space-y-2.5 items-start justify-center h-full font-manrope">
            <p className="w-full text-base leading-3 tracking-wide text-black">
              {name}
            </p>
            <p className="w-24 text-sm font-semibold leading-3 tracking-wider text-indigo-2">
              {action}
            </p>
          </div>
        )}
      </Link>
    )
  }
)

Avatar.defaultProps = {
  href: '#',
  action: 'Show Profile',
}

export default Avatar
